import React from "react";
import placeOne from "./placeOne.png";
import placeTwo from "./placeTwo.png";
import placeThree from "./placeThree.png";
import placeFour from "./placeFour.png";
import placeFive from "./placeFive.png";
import placeSix from "./placeSix.png";
import placeSeven from "./placeSeven.png";
import placeEight from "./placeEight.png";
import placeNine from "./placeNine.png";
import placeTen from "./placeTen.png";
import placeEleven from "./placeEleven.png";
import placeTwelve from "./placeTwelve.png";
import placeThirteen from "./placeThirteen.png";
import placeFourteen from "./placeFourteen.png";
import placeFifteen from "./placeFifteen.png";
import placeSixteen from "./placeSixteen.png";
import stars from "./stars.png";

function Place() {
  return (
    <div>
      <div className="section-how">
        <ul className="place-nav-list">
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              Restaurant
            </a>
          </li>
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              Cottage
            </a>
          </li>
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              Castle
            </a>
          </li>
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              fantastic city
            </a>
          </li>
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              beach
            </a>
          </li>
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              carbins
            </a>
          </li>
          <li>
            <a
              href="/#"
              className="place-nav-link text-black text-decoration-none"
            >
              Farm
            </a>
          </li>
          <li>
            <input placeholder="location" type="text" className="p-2" />
          </li>
        </ul>
        <div className="cards">
          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeOne}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeTwo}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeThree}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeFour}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeFive}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeSix}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeSeven}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeEight}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeNine}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeTen}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeEleven}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeTwelve}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeThirteen}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeFourteen}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeFifteen}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>

          <div className="card p-3" style={{ borderRadius: "13px" }}>
            <img
              src={placeSixteen}
              className="card-img-top img-fluid"
              alt="A House in the metaverse"
            />
            <div class="card-body p-0">
              <div class="card-text mt-3 mb-3">
                <small className="item-a text-start fs-5">Desert King</small>
                <small className="item-b text-end fs-5 fw-bold">
                  1MBT per night
                </small>
                <small className="item-c text-start fs-5">2345km away</small>
                <small className="item-d text-end fs-5">
                  available for 2 weeks stay
                </small>
              </div>
              <img src={stars} alt="Ratings" className="stars mb-2 img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Place;
